// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

export const removeFromAgenda = async (schedule_uuid) => {
  try {
    const fetchParams = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + store.getters.jwt,
        'Content-Type': 'application/json',
      },
    }
    const url = `${tumorBoardBaseUrl}/api/v1/schedule/${schedule_uuid}`
    const response = await fetchWithTimeout(url, fetchParams)
    return response.status
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
